﻿$.fn.dxCtrlContentPlanitiSaisie = function custom_dxCtrlContentPlanitiSaisie(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontentplanitisaisie dx-ctrl");
        this.createInstance(new cdxCtrlContentPlanitiSaisie(this, option));
    }
    return this;
}

window.cdxCtrlContentPlanitiSaisie = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        var ds = [{ id: 0, text: "Détail de l'évènement", ssText: "" },
        { id: 1, text: "Utilisateur", ssText: "Liste des utilisateurs succeptibles de pouvoir prendre en charge une réunion" },
        { id: 2, text: "Jours et horaires", ssText: "Jours et horaires pour la disponibilité des créneaux" },
        { id: 3, text: "Contacts", ssText: "Liste des champs à saisir par votre correspondant" },
        { id: 4, text: "Messages", ssText: "Progrmmez les messages d'annonces" },
        { id: 5, text: "Agendas", ssText: "Liste des agendas à surveiller pour les disponibilités" }]

        dxAccord = $("<div style='background-color:" + theme.backgroundColorTitle + ";'/>").appendTo(container).dxCtrlAccordion({
            stickyTitle: true,
            dataSource: ds,
            selectedIds: [0],
            multiple: false,
            itemClosed: function () { },
            itemOpened: function () { },
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("color", theme.backgroundcolorAccent)
                if (itemIndex == 0) itemElement.css("border-top", "")
                var $Table = $("<table style='width:92%;table-layout:fixed;'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;font-size:180%;font-weight:Bold;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;line-height:1;'>" + itemData.text + "</td>").appendTo($Tr)
                if (typeof itemData.ssText != 'undefined') {
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%;font-size:80%;font-style:italic;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;line-height:1;'>" + itemData.ssText + "</td>").appendTo($Tr)
                }
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding", "20px")
                switch (itemData.id) {
                    case 0: mRempliDetails(itemElement); break;
                    case 1: mRempliUtilisateur(itemElement); break;
                    case 2: mRempliHoraire(itemElement); break;
                    case 3: mRempliChamp(itemElement);; break;
                    case 4: mRempliMessage(itemElement); break;
                    case 5: mRempliAgenda(itemElement); break;
                }
            },
            onContentReady: function (e) {
                e.element.find(".dx-accordion-item-title").css("overflow", "hidden")
            }
        }).dxCtrlAccordion("instance")
    }

    function mRempliDetails(itemElement) {
        itemElement.empty()

        var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo(itemElement).dxCtrlImageData({
            bddCtrl: option.bddCtrl,
            size: 120,
            data: option.data.planiti,
            showTextOnImage: false,
            showText: false,
            fontSizeText: "30px",
            allowDisplayIcone: true,
            srcImgDefaut: parametre.baseAppli.img_logo
        }).dxCtrlImageData("instance");

        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(itemElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:65px;'/>").appendTo($Tr)
        var dxSwitchPartage = $("<div/>").appendTo($Td).dxSwitch({
            width: 60,
            value: (option.data.planiti.partage_agenda == "1"),
            onValueChanged: function (e) {
                if (e.value) {
                    option.data.planiti.partage_agenda = "1"
                    $DivUrl.show()
                } else {
                    option.data.planiti.partage_agenda = "0"
                    $DivUrl.hide()
                }
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("partage_agenda")
            }
        })
        var $Td = $("<td style='width:100%;padding-left:10px;'><span style='opacity:0.3;'>Partager le planiti</span></td>").appendTo($Tr)
        var urlIcs = parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + option.data.planiti.id_planiti + "/planitiics"
        var $DivUrl = $("<div class='state-hover' title='Copier le lien' style='overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-bottom:5px;" + ((option.data.planiti.partage_agenda == "1") ? "" : "display:none;") + "'><i class='fas fa-copy'> </i> <u>" + urlIcs + "</u></div>").appendTo($Td)
        $DivUrl.on("click", function (e) {
            e.stopPropagation()
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(urlIcs).select();
            document.execCommand("copy");
            $temp.remove();
            mNotify("L'adresse de l'agenda a été copiée dans le presse-papier", "success", 6000)
        })

        $("<div style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlTextBox({
            label: "Nom de l'évènement",
            labelMode: 'floating',
            value: option.data.planiti.nom,
            onValueChanged: function (e) {
                option.data.planiti.nom = ((e.value == null) ? "" : e.value)
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("nom")
                option.onValueChanged()
            }
        })
        $("<div style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlTextBox({
            label: "Description de l'évènement",
            labelMode: 'floating',
            multiline: true,
            value: option.data.planiti.description,
            onValueChanged: function (e) {
                option.data.planiti.description = ((e.value == null) ? "" : e.value)
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("description")
                option.onValueChanged()
            }
        })


        //$("<div style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlSelectBox({
        //    label: "Etiquette",
        //    labelMode: 'floating',
        //    displayExpr: "nom",
        //    valueExpr: "id_planiti_etiquette",
        //    dataSource: option.bddCtrl.mGetArray("planiti_etiquette"),
        //    value: option.data.planiti.id_planiti_etiquette,
        //    buttons: [{
        //        focusStateEnabled: false,
        //        name: 'pre',
        //        location: 'after',
        //        options: {
        //            icon: 'fas fa-trash-alt',
        //            hint: "Supprimer définitivement l'étiquette",
        //            stylingMode: 'text',
        //            onClick() {
        //            },
        //        },
        //    }, {
        //        focusStateEnabled: false,
        //        name: 'next',
        //        location: 'after',
        //        options: {
        //            icon: 'fas fa-certificate',
        //            hint: "Créer une nouvelle étiquette",
        //            stylingMode: 'text',
        //            onClick() {
        //            },
        //        },
        //    }],
        //    onValueChanged: function (e) {
        //        option.data.planiti.id_planiti_etiquette = e.value
        //        option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("id_planiti_etiquette")
        //        option.onValueChanged()
        //    }
        //})

        //durée
        $("<div style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlNumberBox({
            label: "Durée",
            labelMode: 'floating',
            value: option.data.planiti.duree_reunion_mn,
            onValueChanged: function (e) {
                option.data.planiti.duree_reunion_mn = e.value
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("duree_reunion_mn")
                option.onValueChanged()
            }
        })


        $("<div style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlNumberBox({
            label: "Nombre de participants maximum",
            labelMode: 'floating',
            value: option.data.planiti.nbre_organisateur,
            onValueChanged: function (e) {
                option.data.planiti.nbre_organisateur = e.value
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("nbre_organisateur")
                option.onValueChanged()
            }
        })

        if (typeof option.data.planiti_lieu == 'undefined') option.data.planiti_lieu = []
        $("<div style='margin:5px 0;'>Lieu de la réunion</div>").appendTo(itemElement)
        var ds = []
        option.data.planiti_lieu.forEach(function (planitiLieu) { ds.push({ id_type_lieu: planitiLieu.id_type_lieu }) })
        $("<div style='margin:5px 0;'/>").appendTo(itemElement).dxCtrlLstCheckBox({
            layout: "vertical",
            dataSource: [{ id_type_lieu: 0, text: "Téléphone" }, { id_type_lieu: 1, text: "Zoom" }],
            value: ds,
            valueExpr: "id_type_lieu",
            itemTemplate: function (itemData, itemElement) {
                switch (parseInt(itemData.id_type_lieu)) {
                    case 0: itemElement.text("Téléphone"); break;
                    case 1: itemElement.text("Vidéo Zoom"); break;
                }
            },
            onValueChanged: function (e) {
                if (typeof e.addedValue != 'undefined') {
                    e.chk.option("disabled", true)
                    var planitiLieu = option.bddCtrl.getObjet("planiti_lieu").mGetNewData()
                    planitiLieu.id_planiti = option.data.planiti.id_planiti
                    planitiLieu.id_type_lieu = e.addedValue.id_type_lieu
                    option.bddCtrl.getObjet(planitiLieu).mSave(function (data) {
                        option.data.planiti_lieu.push(planitiLieu)
                        e.chk.option("disabled", false)
                    })
                }
                if (typeof e.removedValue != 'undefined') {
                    var planitiLieu = option.data.planiti_lieu.filter(function (o) { return o.id_type_lieu == e.removedValue.id_type_lieu })[0]
                    if (typeof planitiLieu != 'undefined') {
                        option.bddCtrl.getObjet(planitiLieu).mDelDataDefinitif()
                        option.data.planiti_lieu.splice(option.data.planiti_lieu.indexOf(planitiLieu), 1)
                    }
                }
                e.addedValue = {}
                e.removedValue = {}
            }
        })

    }
    function mRempliUtilisateur(itemElement) {
        itemElement.empty()

        var lstIdUti = []
        option.data.planiti_utilisateur.forEach(function (data) { lstIdUti.push(data.id_utilisateur) })
        dxUtiCre = $("<div style='padding-top:7px;'/>").appendTo(itemElement).dxCtrlTagUti({
            bddCtrl: option.bddCtrl,
            unitaire: false,
            placeholder: "",
            tooltip: "Filtrer par utilisateur",
            value: lstIdUti,
            onDelete: function (idUti) {
                var dataToDel = option.data.planiti_utilisateur.filter(function (o) { return o.id_utilisateur == idUti })[0]
                option.bddCtrl.getObjet(dataToDel).mDelDataDefintif(function (data) {
                    option.onValueChangedHoraire()
                })
                option.data.planiti_utilisateur.splice(option.data.planiti_utilisateur.indexOf(dataToDel), 1)
                lstIdUti = dxUtiCre.option("value")
            },
            onAdd: function (idUti) {
                var dataPlanitiUti = option.bddCtrl.getObjet("planiti_utilisateur").mGetNewData()
                dataPlanitiUti.id_utilisateur = idUti
                dataPlanitiUti.id_planiti = option.data.planiti.id_planiti
                option.bddCtrl.getObjet(dataPlanitiUti).mSave(function (data) {
                    option.data.planiti_utilisateur.push(dataPlanitiUti)
                    option.onValueChangedHoraire()
                })
                lstIdUti = dxUtiCre.option("value")
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-placeholder").css("font-family", "barlow condensed")
            }
        }).dxCtrlTagUti("instance");
    }

    function mRempliHoraire(itemElement) {
        itemElement.empty()
        var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td colspan='2'/>").appendTo($Tr)
        $("<hr/>").appendTo($Td)
        option.data.planiti_plage_horaire.sort(function (o1, o2) { return ((o2.num_jour == 0) ? -100 : o1.num_jour - o2.num_jour) }).forEach(function (dataPlageHoraire) {
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100px'/>").appendTo($Tr)
            switch (dataPlageHoraire.num_jour) {
                case 0: $Td.text("DIMANCHE"); break;
                case 1: $Td.text("LUNDI"); break;
                case 2: $Td.text("MARDI"); break;
                case 3: $Td.text("MERCREDI"); break;
                case 4: $Td.text("JEUDI"); break;
                case 5: $Td.text("VENDREDI"); break;
                case 6: $Td.text("SAMEDI"); break;
            }
            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            var $DivPlageHoraire = $("<div/>").appendTo($Td).dxCtrlLstTimeBoxInterval({
                value: dataPlageHoraire.plage_horaire,
                intervalMn: 15,
                noDataText: "INDISPONIBLE",
                onValueChanged: function (e) {
                    dataPlageHoraire.plage_horaire = e.value
                    option.bddCtrl.getObjet(dataPlageHoraire).mSaveChamp("plage_horaire", function (data) {
                        option.onValueChangedHoraire()
                    })
                }
            })

            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td colspan='2'/>").appendTo($Tr)
            $("<hr/>").appendTo($Td)
        })

        //hors_jours_feries
        $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlCheckBox({
            text: "(Actuellement, " + ((option.data.planiti.hors_jours_feries == "1") ? "aucun créneau proposé pendant les jours fériés)" : "créneaux proposés pendant les jours fériés)"),
            value: (option.data.planiti.hors_jours_feries == "1"),
            onValueChanged: function (e) {
                option.data.planiti.hors_jours_feries = ((e.value) ? "1" : "0")
                e.component.option("text", "(Actuellement, " + ((option.data.planiti.hors_jours_feries == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"))
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("hors_jours_feries", function () {
                    option.onValueChangedHoraire()
                })
            }
        })

        //heure_decalage_dispo
        $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
            label: "Préavis en heure avant l'ouverture d'un créneau",
            labelMode: 'floating',
            value: option.data.planiti.heure_decalage_dispo,
            onValueChanged: function (e) {
                option.data.planiti.heure_decalage_dispo = e.value
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("heure_decalage_dispo", function () {
                    option.onValueChangedHoraire()
                })
            }
        })

        //ignore_decalage_sur_reunion

        //nb_jour_glissant_dispo
        $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
            label: "Période en jour d'ouverture des créneau",
            labelMode: 'floating',
            value: option.data.planiti.nb_jour_glissant_dispo,
            onValueChanged: function (e) {
                option.data.planiti.nb_jour_glissant_dispo = e.value
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("nb_jour_glissant_dispo", function () {
                    option.onValueChangedHoraire()
                })
            }
        })


        //temps_pause_mn_entre_rdv
        $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
            label: "Minutes tampon entre les créneaux",
            labelMode: 'floating',
            value: option.data.planiti.temps_pause_mn_entre_rdv,
            onValueChanged: function (e) {
                option.data.planiti.temps_pause_mn_entre_rdv = e.value
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("temps_pause_mn_entre_rdv", function () {
                    option.onValueChangedHoraire()
                })
            }
        })

        //increment_heure_debut_mn
        $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
            label: "Temps en Minutes entre les créneaux proposés",
            labelMode: 'floating',
            value: option.data.planiti.increment_heure_debut_mn,
            onValueChanged: function (e) {
                option.data.planiti.increment_heure_debut_mn = e.value
                option.bddCtrl.getObjet(option.data.planiti).mSaveChamp("increment_heure_debut_mn", function () {
                    option.onValueChangedHoraire()
                })
            }
        })
    }
    function mRempliChamp(itemElement) {
        itemElement.empty()
        $("<div/>").appendTo(itemElement).dxList({
            dataSource: option.data.planiti_champ,
            itemDragging: {
                allowReordering: true
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding-right", "3px")
                itemElement.css("padding-left", "3px")
                var $Table = $("<table style='width:100%;'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlSwitch({
                    value: (itemData.demander == "1"),
                    hint: "Proposer de saisir le champ",
                    onValueChanged: function (e) {
                        itemData.demander = ((e.value) ? "1" : "0")
                        option.bddCtrl.getObjet(itemData).mSaveChamp("demander")
                        $TdObligatoire.css("opacity", ((itemData.demander == 1) ? "1" : "0.3"))
                        $TdNom.css("opacity", ((itemData.demander == 1) ? "1" : "0.3"))
                        dxSwitchObligatoire.option("disabled", !e.value)
                    }
                })
                var $TdObligatoire = $("<td style='width:1px;opacity:" + ((itemData.demander == 1) ? "1" : "0.3") + ";'/>").appendTo($Tr)
                var dxSwitchObligatoire = $("<div/>").appendTo($TdObligatoire).dxCtrlSwitch({
                    value: (itemData.obligatoire == "1"),
                    disabled: (itemData.demander == "0"),
                    hint: "Obliger la saisie du champ",
                    onValueChanged: function (e) {
                        itemData.obligatoire = ((e.value) ? "1" : "0")
                        option.bddCtrl.getObjet(itemData).mSaveChamp("obligatoire")
                    }
                }).dxCtrlSwitch("instance")
                var $TdNom = $("<td style='width:100%;opacity:" + ((itemData.demander == 1) ? "1" : "0.3") + ";'/>").appendTo($Tr)
                switch (parseInt(itemData.id_champ_table)) {
                    case parametre.champ.id_champ_table_nomstructure: $TdNom.text("Société"); break;
                    case parametre.champ.id_champ_table_nomprenom: $TdNom.text("Nom et prénom"); break;
                    case parametre.champ.id_champ_table_adr: $TdNom.text("Adresse"); break;
                    case parametre.champ.id_champ_table_tel: $TdNom.text("Téléphone fixe"); break;
                    case parametre.champ.id_champ_table_mobile: $TdNom.text("Téléphone mobile"); break;
                    case parametre.champ.id_champ_table_siteweb: $TdNom.text("Site web"); break;
                    case parametre.champ.id_champ_table_email: $TdNom.text("Email"); break;
                }
            },
            onItemReordered: function (e) {
                option.data.planiti_champ.move(e.fromIndex, e.toIndex)
                option.data.planiti_champ.forEach(function (planitiChamp, idx) {
                    planitiChamp.tri = idx
                })
                option.bddCtrl.mAjaxCall({ command: "reorderplanitichamp", data: option.data.planiti_champ })
            }
        })
    }
    function mRempliMessage(itemElement) {
        itemElement.empty()
        $("<div/>").appendTo(itemElement).dxCtrlButton({
            icon: "fas fa-plus",
            hint: "Ajouter un nouveau message de rappel",
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: e.component.element(),
                    contentTemplate: function (contentElement) {
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "Confirmation",
                            onClick: function (e) { mCreeNewMessage(0) }
                        })
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "Rappel",
                            onClick: function (e) { mCreeNewMessage(1) }
                        })
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "Annulation",
                            onClick: function (e) { mCreeNewMessage(2) }
                        })
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "Reprogrammation",
                            onClick: function (e) { mCreeNewMessage(3) }
                        })

                        function mCreeNewMessage(idTypeMessage) {
                            var newPlanitiMessage = option.bddCtrl.getObjet("planiti_message").mGetNewData()
                            newPlanitiMessage.id_planiti = option.data.planiti.id_planiti
                            newPlanitiMessage.id_type_message = idTypeMessage
                            newPlanitiMessage.id_type_canal = 0
                            newPlanitiMessage.id_type_destinataire = 0
                            if (idTypeMessage == 1) newPlanitiMessage.nb_jour_avant = 1
                            option.bddCtrl.getObjet(newPlanitiMessage).mSave(function (idPlanitiMessage) {
                                option.data.planiti_message.push(newPlanitiMessage)
                                mRempliMessage(itemElement)
                            })
                            tt.hide()
                        }
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        })
        var $Table = $("<table style='width:100%;'/>").appendTo(itemElement)
        option.data.planiti_message.sort(function (o1, o2) { return o1.nb_jour_avant - o2.nb_jour_avant }).forEach(function (planitiMessage) {
            var $Tr = $("<tr/>").appendTo($Table)
            switch (parseInt(planitiMessage.id_type_message)) {
                case 0:
                    var $Td = $("<td style='width:1px'>CONFIRMATION</td>").appendTo($Tr)
                    break;
                case 1:
                    var $Td = $("<td style='width:1px'>RAPPEL</td>").appendTo($Tr)
                    break;
                case 2:
                    var $Td = $("<td style='width:1px'>ANNULATION</td>").appendTo($Tr)
                    break;
                case 3:
                    var $Td = $("<td style='width:1px'>REPROGRAMMATION</td>").appendTo($Tr)
                    break;
            }
            var $Td = $("<td style='width:34%'/>").appendTo($Tr)
            var dsCanal = ["Email", "SMS"]
            $("<div/>").appendTo($Td).dxCtrlSelectBox({
                label: "Canal",
                labelMode: 'floating',
                dataSource: dsCanal,
                value: dsCanal[planitiMessage.id_type_canal],
                onValueChanged: function (e) {
                    planitiMessage.id_type_canal = dsCanal.indexOf(e.value)
                    option.bddCtrl.getObjet(planitiMessage).mSaveChamp("id_type_canal")
                    option.onValueChanged()
                }
            })
            var $Td = $("<td style='width:66%' " + ((planitiMessage.id_type_message == 1) ? "" : "colspan='2'") + "/>").appendTo($Tr)
            var dsDest = ["Participant", "Utilisateur", "Invité", "Participant et utilisateur", "Participant et invité", "Participant, utilisateur et invité"]
            $("<div/>").appendTo($Td).dxCtrlSelectBox({
                label: "Destinataire",
                labelMode: 'floating',
                dataSource: dsDest,
                value: dsDest[planitiMessage.id_type_destinataire],
                onValueChanged: function (e) {
                    planitiMessage.id_type_destinataire = dsDest.indexOf(e.value)
                    option.bddCtrl.getObjet(planitiMessage).mSaveChamp("id_type_destinataire")
                    option.onValueChanged()
                }
            })
            if (planitiMessage.id_type_message == 1) {
                $Td.css("width", "33%")
                var $Td = $("<td style='width:33%'/>").appendTo($Tr)
                var dsJourAvant = ["15 minutes avant", "1 jour avant", "2 jours avant", "3 jours avant", "4 jours avant", "5 jours avant"]
                $("<div/>").appendTo($Td).dxCtrlSelectBox({
                    label: "Nbre jour avant réunion",
                    labelMode: 'floating',
                    dataSource: dsJourAvant,
                    value: dsJourAvant[planitiMessage.nb_jour_avant],
                    onValueChanged: function (e) {
                        planitiMessage.nb_jour_avant = dsJourAvant.indexOf(e.value)
                        option.bddCtrl.getObjet(planitiMessage).mSaveChamp("nb_jour_avant")
                        option.onValueChanged()
                    }
                })
            }
            var $Td = $("<td style='width:1px'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-xmark",
                onClick: function (e) {
                    option.bddCtrl.getObjet(planitiMessage).mDelDataDefinitif()
                    option.data.planiti_message.splice(option.data.planiti_message.indexOf(planitiMessage), 1)
                    $Tr.remove()
                    option.onValueChanged()
                }
            })
        })
    }

    var $DivAgenda = null
    var $DivAgendaExterne = null
    function mRempliAgenda(itemElement) {
        itemElement.empty()

        if (typeof option.data.planiti_agenda == 'undefined') option.data.planiti_agenda = []
        if (typeof option.data.planiti_agenda_externe == 'undefined') option.data.planiti_agenda_externe = []

        $("<div style='padding:0 5px 5px 5px;font-style:italic;opacity:0.3;font-size:80%;'>Tous les rendez-vous des agendas ci-dessous seront considérés comme des plages horaires prises</div>").appendTo(itemElement)

        var $Table = $("<table/>").appendTo(itemElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;font-size:140%;'>Liste des agendas internes</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-plus",
            hint: "Rajouter/enlever des agendas de l'application",
            onClick: function (e) {
                var lstIdAgendaSelected = []
                option.data.planiti_agenda.forEach(function (data) { lstIdAgendaSelected.push(data.id_agenda) })
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: e.component.element(),
                    width: 400,
                    contentTemplate: function (contentElement) {
                        contentElement.css("text-align", "left")
                        $("<div/>").appendTo(contentElement).dxCtrlLstAgenda({
                            bddCtrl: option.bddCtrl,
                            showRappel: false,
                            showProjet: false,
                            showPlaniti: false,
                            showUtilisateur: false,
                            lstIdAgendaSelected: lstIdAgendaSelected,
                            onSelectionChanged: function (lstIdAgenda) {
                                //on enlève les agendas enleve
                                option.data.planiti_agenda.forEach(function (dataPlanitAgenda) {
                                    if (!lstIdAgenda.contains(dataPlanitAgenda.id_agenda)) {
                                        option.bddCtrl.getObjet(dataPlanitAgenda).mDelDataDefinitif()
                                        option.data.planiti_agenda.splice(option.data.planiti_agenda.indexOf(dataPlanitAgenda), 1)
                                    }
                                })
                                //on rajoute les agendas rajouté
                                lstIdAgenda.forEach(function (idAgenda) {
                                    if (!lstIdAgendaSelected.contains(idAgenda)) {
                                        var dataPlanitAgenda = option.bddCtrl.getObjet("planiti_agenda").mGetNewData()
                                        dataPlanitAgenda.id_agenda = idAgenda
                                        dataPlanitAgenda.id_planiti = option.data.planiti.id_planiti
                                        option.bddCtrl.getObjet(dataPlanitAgenda).mSave()
                                        option.data.planiti_agenda.push(dataPlanitAgenda)
                                    }
                                })
                                option.onValueChangedHoraire()
                            }
                        })
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        })
        $DivAgenda = $("<div/>").appendTo(itemElement)
        mRempliAgendaInterne()

        $("<hr/>").appendTo(itemElement)

        var $Table = $("<table/>").appendTo(itemElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;font-size:140%;'>Liste des agendas externes</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-plus",
            hint: "Rajouter des agendas externes",
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: e.component.element(),
                    width: 400,
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding","40px")
                        var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                        contentElement.css("padding", "20px")
                        var dxNom = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            label: "Nom de l'agenda externe",
                            labelMode: 'floating',
                            value: ""
                        }).dxCtrlTextBox("instance")
                        var dxUrl = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            label: "Url de l'agenda externe",
                            labelMode: 'floating',
                            value: "",
                            onValueChanged: function (e) {
                                //if (!(/^(http|https|ftp):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(dxUrl.option("value")))) {
                                //    mNotify("L'url de l'agenda externe n'est pas valide", "warning", 6000)
                                //    dxUrl.option("value", "")
                                //    dxUrl.focus()
                                //    return
                                //}
                                //option.bddCtrl.mAjaxCall({
                                //    command: "verifyurlagendaexterne",
                                //    url: dxUrl.option("value")
                                //}, function (data) {
                                //    if (data.ok != "1") {
                                //        mNotify("L'url que vous avez saisie n'est pas valide", "warning", 6000)
                                //        dxUrl.option("value", "")
                                //        dxUrl.focus()
                                //    }
                                //})
                            }
                        }).dxCtrlTextBox("instance")

                        var $Div = $("<div style='text-align:right;'/>").appendTo(contentElement)
                        $("<div style='display:inline-block;'/>").appendTo($Div).dxCtrlButton({
                            text: "Ajouter",
                            onClick: function (e) {
                                if (dxNom.option("value") == null || dxNom.option("value").length == 0) {
                                    mNotify("Vous devez saisir un nom pour l'agenda externe", "warning", 6000)
                                    dxNom.focus()
                                    return
                                }
                                if (dxUrl.option("value") == null || dxUrl.option("value").length == 0) {
                                    mNotify("Vous devez saisir une url pour l'agenda externe", "warning", 6000)
                                    dxNom.focus()
                                    return
                                }
                                if (!isValidUrl(dxUrl.option("value"))) {
                                    mNotify("Vous devez saisir une url valide pour l'agenda externe", "warning", 6000)
                                    dxUrl.focus()
                                    return
                                }
                                jauge.mShow()
                                option.bddCtrl.mAjaxCall({ command: "testurlagendaexterneetgetnom", url: dxUrl.option("value") }, function (data) {
                                    if (typeof data.nom_agenda == 'undefined') {
                                        //on a pas trouvé d'agenda avec l'url
                                        mNotify("L'url que vous avez saisie n'est pas valide", "warning", 6000)
                                        dxUrl.focus()
                                        jauge.mHide()
                                    } else {
                                        var dataPlanitAgendaExterne = option.bddCtrl.getObjet("planiti_agenda_externe").mGetNewData()
                                        dataPlanitAgendaExterne.nom = dxNom.option("value")
                                        dataPlanitAgendaExterne.url = dxUrl.option("value")
                                        dataPlanitAgendaExterne.id_planiti = option.data.planiti.id_planiti
                                        option.bddCtrl.getObjet(dataPlanitAgendaExterne).mSave()
                                        option.data.planiti_agenda_externe.push(dataPlanitAgendaExterne)
                                        mRempliAgendaExterne()
                                        option.onValueChangedHoraire()
                                        tt.hide()
                                        jauge.mHide()
                                    }
                                })

                            }
                        })


                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        })
        $DivAgendaExterne = $("<div/>").appendTo(itemElement)
        mRempliAgendaExterne()

    }
    function mRempliAgendaInterne() {
        $DivAgenda.empty()
        if (option.data.planiti_agenda.length == 0) {
            $("<div style='text-align:center;opacity:0.5;padding:10px;'>Aucun agenda</div>").appendTo($DivAgenda)
        } else {
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($DivAgenda)
            option.data.planiti_agenda.forEach(function (dataPlanitiAgenda) {
                var dataAgenda = option.bddCtrl.mGetArray("agenda").filter(function (o) { return o.id_agenda == dataPlanitiAgenda.id_agenda })[0]
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + dataAgenda.nom + "</td>").appendTo($Tr)
                var $Td = $("<td style='width:50px;'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-xmark",
                    onClick: function (e) {
                        $Tr.remove()
                        option.bddCtrl.getObjet(dataPlanitiAgenda).mDelDataDefinitif()
                        option.data.planiti_agenda.splice(option.data.planiti_agenda.indexOf(dataPlanitiAgenda), 1)
                        mRempliAgendaInterne()
                        option.onValueChangedHoraire()
                    }
                })
            })
        }
    }
    function mRempliAgendaExterne() {
        $DivAgendaExterne.empty()
        if (option.data.planiti_agenda_externe.length == 0) {
            $("<div style='text-align:center;opacity:0.5;padding:10px;'>Aucun agenda externe</div>").appendTo($DivAgendaExterne)
        } else {
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($DivAgendaExterne)
            option.data.planiti_agenda_externe.forEach(function (dataPlanitiAgenda) {
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + dataPlanitiAgenda.nom + "<br/>" + dataPlanitiAgenda.url + "</td>").appendTo($Tr)
                var $Td = $("<td style='width:50px;'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-xmark",
                    onClick: function (e) {
                        $Tr.remove()
                        option.bddCtrl.getObjet(dataPlanitiAgenda).mDelDataDefinitif()
                        option.data.planiti_agenda_externe.splice(option.data.planiti_agenda.indexOf(dataPlanitiAgenda), 1)
                        mRempliAgendaExterne()
                        option.onValueChangedHoraire()
                    }
                })
            })
        }
    }

    this.element = function () { return container; }

    mConstruit();
}